import React from 'react'; 
import { useLocation } from 'react-router-dom';
import styles from '../styles/Booking.module.css';
import callIcon from '../assets/callicon.png';  // Import call icon
import emailIcon from '../assets/emailicon.png'; // Import email icon

export default function Booking() {
    const location = useLocation();
    const { counselor } = location.state || {};

    if (!counselor) {
      return <p>No counselor selected</p>;
    }

    return (
        <div className="container mx-auto">
            <div className="flex justify-center items-center h-screen">
                <div className={styles.glass}>
                    {/* Image Section */}
                    <div className="image-container flex justify-center ">
                        <img
                            src={counselor.imgUrl || 'https://i.imgur.com/placeholder.jpg'}
                            alt="Counselor"
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = 'https://i.imgur.com/placeholder.jpg';
                            }}
                            className="rounded-lg shadow-md"
                            style={{ maxWidth: '100%', height: 'auto', maxHeight: '250px' }}
                        />
                    </div>

                    {/* Title and Details */}
                    <div className="title-container">
                      <div className={styles.titleBox}>
                          {/* License */}
                          <p className="License-text font-semibold text-lg" style={{ justifySelf: 'start' }}>
                            {counselor.License}
                          </p>   
                                               
                          {/* Email */}
                          <p style={{ justifySelf: 'end' }}>
                              <a
                                  href={`mailto:${counselor.email}`}
                                  style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}
                              >
                                  <img src={emailIcon} alt="Email" style={{ width: '40px' }} />
                              </a>
                          </p>
                          
                          {/* Phone */}
                          <p>
                              <a href={`tel:${counselor.phoneno}`} style={{ display: 'flex', alignItems: 'center' }}>
                                  <img src={callIcon} alt="Call" style={{ width: '40px', marginRight: '8px' }} />
                              </a>
                          </p>
                          
                          {/* Contact */}
                          <p style={{ justifySelf: 'start' }}><strong>{counselor.contact}</strong></p>
                      </div>
                    </div>

                    <div className={styles.singleColumnBox}>
                      <p style={{ alignSelf: 'flex-start', fontWeight: 'bold' }}>About</p>
                      <p>{counselor.about}</p>
                    </div>

                    {/* Removed <Navigation /> to prevent duplication */}
                </div>
            </div>
        </div>
    );
}
